import productcupcake_tester_t_shrit_by_john_doe from './product-cupcake_tester_t_shrit_by_john_doe';
export default {
  'product-cupcake_tester_t_shrit_by_john_doe' : productcupcake_tester_t_shrit_by_john_doe
};



// WEBPACK FOOTER //
// ./src/store/data/products/index.js